import { render, staticRenderFns } from "./ModalPerizia.vue?vue&type=template&id=4f473275"
import script from "./ModalPerizia.vue?vue&type=script&lang=js"
export * from "./ModalPerizia.vue?vue&type=script&lang=js"
import style0 from "./ModalPerizia.vue?vue&type=style&index=0&id=4f473275&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports